function SmsCtrl($scope, $timeout, $state) {

	$scope.send = function () {
		sendToSmsService();
	};

	function sendToSmsService() {
		console.log("Executing smsServiceTestSms method...");
		store.save({
			path: '/ag/smsServiceTestSms',
			queryParams: {
				provider: $scope.sendModel.provider.name,
				number: $scope.sendModel.number,
				message: $scope.sendModel.message,
			},
			success: function (data) {
				$scope.result = data;
			},
		});
	}

	$scope.modifyPriorities = function () {
		$scope.modifyPrioritiesResult = 'Sending...';
		store.save({
			path: '/ag/modifyMobileProvidersPriorities',
			data: $scope.mobileProviders,
			dataObj: 'json',
			success: function (data) {
				$scope.modifyPrioritiesResult = data.status === 'OK' ? 'OK' : `${data.status}: ${data.notifications[0].message}`;
			},
		});
	}

	const ctrl = this;

	ctrl.$onInit = function() {
		populateProviderPriorities();
		store.fetch({
			method: 'GET',
			url: '/ag/getMobileProvidersFromSmsService',
			success: function (data) {
				$scope.mobileProviders = data;
				$scope.providersConfig = data;
			}
		});
	}
	function fetchMobileProviders() {
		return fetch('/ag/getMobileProvidersFromSmsService')
			.then(response => response.json())
			.catch(error => {
				console.error('Error fetching mobile providers:', error);
			});
	}

	function populateProviderPriorities() {
		fetchMobileProviders()
			.then(providers => {
				providers.forEach(provider => {
					const element = document.getElementById(provider.name);
					if (element) {
						element.value = provider.priority;
					}
				});
			});
	}

	$scope.SmsModifyPriorities = function () {
		fetchMobileProviders()
			.then(providers => {
				const queryParams = {};
				providers.forEach(provider => {
					const element = document.getElementById(provider.name);
					if (element) {
						queryParams[`${provider.name.toLowerCase()}Priority`] = parseInt(element.value);
					}
				});

				store.save({
					path: '/ag/SmsServiceUpdateProvidersPriorities',
					queryParams: queryParams,
					success: function (data) {
						$scope.SmsUpdateProvidersResult = data;
					},
				});
			})
			.catch(error => {
				console.error('Error modifying SMS priorities:', error);
			});
	};
}
